












































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMTextInput from '@/web/components/common/HMTextInput.vue';
import { notify } from '@/web/utils/notify';
import { errorToMessage } from '@/core/utils/errors';
import TipJarModal from '@/web/components/settings/TipJarModal.vue';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'TipJar',
  components: { HMTextInput },
  props: {
    showTipJarPage: {
      type: Boolean,
      default: true,
    },
    disabledTitle: {
      type: String,
      default: 'SETTINGS.TEXT.ENABLE_STRIPE_FOR_TIP_JAR',
    },
  },
  computed: {
    ...mapGetters({
      paymentInfo: 'setting/paymentInfo',
      teacherStudioUrl: 'user/teacherStudioUrl',
      studio: 'studio/currentStudio',
      teacher: 'user/teacher',
    }),
    tipJarLink() {
      return getStudentViewURL(this.teacherStudioUrl, '/tips', null);
    },
    paymentGatewayIsStripe() {
      return this.paymentInfo.payment_gateway === 'stripe';
    },
  },
  data() {
    return {
      tipJar: null,
    };
  },
  methods: {
    async update() {
      try {
        await this.$store.dispatch('setting/updateTipJarInfo', this.tipJar);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$tc('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$tc('SETTINGS.NOTIFICATIONS.TIP_JAR_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
    },
    copy(id: string, value: string): void {
      const element = document.getElementById(id)!;
      const range = document.createRange();
      range.selectNode(element);
      const selection = window.getSelection()!;
      selection.removeAllRanges();
      selection.addRange(range);

      this.$copyText(value).then(() => {
        notify(this.$t('NOTIFICATIONS.TEXT.COPIED') as string, value);
      });

      setTimeout(() => selection.removeAllRanges());
    },
    showTipModal() {
      this.$modal.show(TipJarModal, {
        studioName: this.teacher.studio_name,
        currency: this.paymentInfo.currency,
        clickable: false,
      });
    },
  },
  async mounted() {
    await this.$store.dispatch('setting/getPaymentInfo');
    this.tipJar = await this.$store.dispatch('setting/getTipJarInfo');
  },
});
